import React from 'react';
import { TabProps } from '../types';
import { Icon, Header } from 'semantic-ui-react';
import { DesignSystem } from '../../../styles/designSystem';

const PartnersTab: React.FC<TabProps> = ({ data }) => {
  return (
    <div style={{
      padding: '1rem',
      background: DesignSystem.colors.section.gradient,
      minHeight: '30vh'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '10px',
        padding: '1rem',
        boxShadow: '0 8px 15px rgba(0,0,0,0.08)',
        border: '1px solid rgba(255,255,255,0.8)'
      }}>
        <Header as="h2" style={{
          color: '#2c3e50',
          textAlign: 'center',
          marginBottom: '1rem',
          fontWeight: '700',
          fontSize: '1.3rem'
        }}>
          <div style={{
            background: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            <Icon name="users" size="large" />
            Sócios e Administradores
          </div>
        </Header>

        <div style={{
          background: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1.5rem',
          color: 'white',
          textAlign: 'center',
          boxShadow: '0 12px 25px rgba(155, 89, 182, 0.3)'
        }}>
          <Icon name="user circle" size="large" />
          <Header as="h3" style={{ color: 'white', margin: '0.75rem 0', fontSize: '1.3rem' }}>
            Quadro de Sócios e Administradores (QSA)
          </Header>
          <p style={{ color: 'rgba(255,255,255,0.8)', margin: 0, fontSize: '0.9rem' }}>
            Informações sobre os sócios e administradores da empresa
          </p>
        </div>

        {((data.qsa && data.qsa.length > 0) || (data.partners && data.partners.length > 0)) ? (
          <div>
            {(data.qsa || []).map((socio, index) => (
              <div key={index} style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '15px',
                padding: '2rem',
                marginBottom: '1.5rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
                border: '1px solid rgba(155, 89, 182, 0.1)',
                borderLeft: '5px solid #9b59b6',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
                    borderRadius: '50%',
                    padding: '1rem',
                    color: 'white',
                    minWidth: '60px',
                    minHeight: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name="user" size="large" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#9b59b6',
                      fontSize: '1.3rem',
                      fontWeight: '700',
                      marginBottom: '0.5rem'
                    }}>
                      {socio.nome || 'Nome não informado'}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '1rem',
                      marginBottom: '1rem',
                      lineHeight: '1.4'
                    }}>
                      <strong>Qualificação:</strong> {socio.qual || 'Não informado'}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                      {socio.paisOrigem && (
                        <div style={{
                          background: 'rgba(155, 89, 182, 0.1)',
                          borderRadius: '8px',
                          padding: '0.75rem',
                          border: '1px solid rgba(155, 89, 182, 0.2)'
                        }}>
                          <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            País de Origem
                          </div>
                          <div style={{ color: '#2c3e50', fontWeight: '500' }}>
                            {socio.paisOrigem}
                          </div>
                        </div>
                      )}

                      {socio.nomeRepLegal && (
                        <div style={{
                          background: 'rgba(155, 89, 182, 0.1)',
                          borderRadius: '8px',
                          padding: '0.75rem',
                          border: '1px solid rgba(155, 89, 182, 0.2)'
                        }}>
                          <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Representante Legal
                          </div>
                          <div style={{ color: '#2c3e50', fontWeight: '500' }}>
                            {socio.nomeRepLegal}
                          </div>
                        </div>
                      )}

                      {socio.qualRepLegal && (
                        <div style={{
                          background: 'rgba(155, 89, 182, 0.1)',
                          borderRadius: '8px',
                          padding: '0.75rem',
                          border: '1px solid rgba(155, 89, 182, 0.2)'
                        }}>
                          <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Qualificação do Representante
                          </div>
                          <div style={{ color: '#2c3e50', fontWeight: '500' }}>
                            {socio.qualRepLegal}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            {(data.partners || []).map((partner, index) => (
              <div key={`partner-${index}`} style={{
                background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
                borderRadius: '15px',
                padding: '2rem',
                marginBottom: '1.5rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
                border: '1px solid rgba(155, 89, 182, 0.1)',
                borderLeft: '5px solid #9b59b6',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 15px 30px rgba(0,0,0,0.1)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.05)';
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
                  <div style={{
                    background: 'linear-gradient(135deg, #9b59b6, #8e44ad)',
                    borderRadius: '50%',
                    padding: '1rem',
                    color: 'white',
                    minWidth: '60px',
                    minHeight: '60px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Icon name="user" size="large" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      color: '#9b59b6',
                      fontSize: '1.3rem',
                      fontWeight: '700',
                      marginBottom: '0.5rem'
                    }}>
                      {partner.nome || 'Nome não informado'}
                    </div>
                    <div style={{
                      color: '#2c3e50',
                      fontSize: '1rem',
                      marginBottom: '1rem',
                      lineHeight: '1.4'
                    }}>
                      <strong>Qualificação:</strong> {partner.qualificacao || 'Não informado'}
                    </div>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                      {partner.pais && (
                        <div style={{
                          background: 'rgba(155, 89, 182, 0.1)',
                          borderRadius: '8px',
                          padding: '0.75rem',
                          border: '1px solid rgba(155, 89, 182, 0.2)'
                        }}>
                          <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            País de Origem
                          </div>
                          <div style={{ color: '#2c3e50', fontWeight: '500' }}>
                            {partner.pais}
                          </div>
                        </div>
                      )}

                      {partner.representanteLegal && (
                        <div style={{
                          background: 'rgba(155, 89, 182, 0.1)',
                          borderRadius: '8px',
                          padding: '0.75rem',
                          border: '1px solid rgba(155, 89, 182, 0.2)'
                        }}>
                          <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Representante Legal
                          </div>
                          <div style={{ color: '#2c3e50', fontWeight: '500' }}>
                            {partner.representanteLegal}
                          </div>
                        </div>
                      )}

                      {partner.qualificacaoRepresentante && (
                        <div style={{
                          background: 'rgba(155, 89, 182, 0.1)',
                          borderRadius: '8px',
                          padding: '0.75rem',
                          border: '1px solid rgba(155, 89, 182, 0.2)'
                        }}>
                          <div style={{ color: '#7f8c8d', fontSize: '0.9rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Qualificação do Representante
                          </div>
                          <div style={{ color: '#2c3e50', fontWeight: '500' }}>
                            {partner.qualificacaoRepresentante}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{
            background: 'linear-gradient(135deg, #f8f9fa, #ffffff)',
            borderRadius: '15px',
            padding: '3rem',
            textAlign: 'center',
            boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
            border: '1px solid rgba(155, 89, 182, 0.1)'
          }}>
            <Icon name="user outline" size="huge" style={{ color: '#bdc3c7' }} />
            <Header as="h3" style={{ color: '#7f8c8d', margin: '1rem 0' }}>
              Nenhuma informação disponível
            </Header>
            <p style={{ color: '#95a5a6', fontSize: '1.1rem' }}>
              Não há informações de sócios disponíveis para este CNPJ.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PartnersTab;
